import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Displays weather.", -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Enter a city name, zip code, IP address or latitude/longitude.", -1)
const _hoisted_7 = { class: "zone-weather__callout mt-3 align-items-stretch d-block" }
const _hoisted_8 = { class: "d-flex flex-grow-1 align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--callout",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5A7,7 0 0,0 5,12A7,7 0 0,0 12,19A7,7 0 0,0 19,12A7,7 0 0,0 12,5Z" })
], -1)
const _hoisted_10 = { class: "flex-grow-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "callout__location-label" }, "WEATHER FOR", -1)
const _hoisted_12 = {
  key: 0,
  style: {"color":"#424850"}
}
const _hoisted_13 = {
  key: 1,
  style: {"color":"#424850"}
}
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.contentName), 1),
        _hoisted_3
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_form_item, { label: "Location" }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  (_ctx.content.location && _ctx.content.location.name)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.content.location.name) + ", " + _toDisplayString(_ctx.content.location.region) + ", " + _toDisplayString(_ctx.content.location.country), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.content.location), 1))
                ]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  onClick: _ctx.onEditLocation,
                  class: "ms-4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.editLocation ? 'Done' : 'Edit'), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_Transition, { name: "fade-down" }, {
                default: _withCtx(() => [
                  (_ctx.editLocation)
                    ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                        key: 0,
                        modelValue: _ctx.newLocation,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newLocation) = $event)),
                        "fetch-suggestions": _ctx.searchLocations,
                        onSelect: _ctx.handleLocationSelect,
                        style: {"padding-top":"1em","width":"100%"},
                        debounce: 1000,
                        placeholder: "Search City or Zip Code"
                      }, {
                        prefix: _withCtx(() => [
                          _createVNode(_component_Icon, { icon: _ctx.mdiMagnify }, null, 8, ["icon"])
                        ]),
                        default: _withCtx(({ item }) => [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(item.name) + ", " + _toDisplayString(item.region) + ", " + _toDisplayString(item.country), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "fetch-suggestions", "onSelect"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form_item, {
            class: "col-lg-6",
            label: "Temperature Scale"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.content.temperatureScale,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.content.temperatureScale) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "Fahrenheit",
                    value: "Fahrenheit"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Celsius",
                    value: "Celsius"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}